import React from "react";
import { Route, Routes } from "react-router-dom";

import { AppRoute } from "./app-route";
import BetaHome from "./beta/pages/betaHome/betaHome";
import Applications from "./main/pages/applications/applications";
import ChooseAccount from "./main/pages/choose-account/choose-account";
import ErrorPage from "./main/pages/error-page/error-page";
import Home from "./main/pages/home/home";
import Profile from "./main/pages/profile/profile";
import ServiceCategory from "./main/pages/service-category/service-category";
import SignedOutPage from "./main/pages/signed-out-page/signed-out-page";
import SingleSignOutPage from "./main/pages/single-sign-out-page/single-sign-out-page";

import "@innovationnorway/lighthouse-css";
import "../node_modules/@in/component-library/dist/component-library.css";
import "./custom.scss";

const App = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AppRoute requireVerified>
            <Home />
          </AppRoute>
        }
      />

      <Route
        path="/beta"
        element={
          <AppRoute>
            <BetaHome />
          </AppRoute>
        }
      />

      <Route
        path="/choose-account"
        element={
          <AppRoute>
            <ChooseAccount />
          </AppRoute>
        }
      />

      <Route
        path="/service-category/:slug"
        element={
          <AppRoute requireVerified>
            <ServiceCategory />
          </AppRoute>
        }
      />
      <Route
        path="/applications"
        element={
          <AppRoute requireVerified>
            <Applications />
          </AppRoute>
        }
      />
      <Route
        path="/edit-contact"
        element={
          <AppRoute>
            <Profile />
          </AppRoute>
        }
      />
      <Route
        path="/signed-out"
        element={
          <AppRoute allowAnonymous>
            <SignedOutPage />
          </AppRoute>
        }
      />
      <Route
        path="/single-sign-out"
        element={
          <AppRoute allowAnonymous={true}>
            <SingleSignOutPage />
          </AppRoute>
        }
      />
      <Route
        path="/single-log-out"
        element={
          <AppRoute>
            <SingleSignOutPage />
          </AppRoute>
        }
      />
      <Route
        path="/error"
        element={
          <AppRoute>
            <ErrorPage />
          </AppRoute>
        }
      />
    </Routes>
  );
};

export default App;
